import { motion } from 'framer-motion'
import { useAtomValue } from 'jotai'
import SmartButton from 'src/common/components/Buttons/SmartButton'
import MarketDepthChart from 'src/common/components/MarketDepthChart/MarketDepthChart'
import {
  buyTokenAmountAtom,
  buyTokenAtom,
  sellTokenAmountAtom,
  sellTokenAtom,
} from '../../stores/trade-store'
import TokenPairSelect from '../TokenPairSelect'
import TradePricePerToken from '../TradePricePerToken'
import useSwapFormControls from './hooks/useSwapFormControls'
import useSwapFormState from './hooks/useSwapFormState'
import useSwapSyncOffers from './hooks/useSwapSyncOffers'

const SwapTokens = () => {
  const sellToken = useAtomValue(sellTokenAtom)
  const sellTokenAmount = useAtomValue(sellTokenAmountAtom)
  const buyToken = useAtomValue(buyTokenAtom)
  const buyTokenAmount = useAtomValue(buyTokenAmountAtom)

  const { pairOffersLoading } = useSwapSyncOffers({
    sellToken,
    sellTokenAmount,
    buyToken,
    buyTokenAmount,
  })

  const {
    handleSellTokenAmountChange,
    handleBuyTokenAmountChange,
    handleBuyTokenChange,
    handleSwap,
    handleSwithToLimit,
    handlePreviewClick,
    handleAmountSelect,
  } = useSwapFormControls()

  const {
    loading,
    actionStatusMessage,
    isActionDisabled,
    hasAvailableOffers,
    hasOffersToTake,
  } = useSwapFormState()

  return (
    <div className='flex flex-col gap-2'>
      <TokenPairSelect
        onSellTokenAmountChange={handleSellTokenAmountChange}
        onBuyTokenAmountChange={handleBuyTokenAmountChange}
        onBuyTokenChange={handleBuyTokenChange}
        onSwap={handleSwap}
        excludeNFT
      />
      {hasAvailableOffers && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <TradePricePerToken />
        </motion.div>
      )}

      {sellToken && buyToken && (
        <MarketDepthChart
          sellToken={sellToken}
          buyToken={buyToken}
          onAmountSelect={handleAmountSelect}
        />
      )}

      <SmartButton
        className='w-full'
        loading={loading || pairOffersLoading}
        onClick={hasOffersToTake ? () => handlePreviewClick() : handleSwithToLimit}
        disabled={isActionDisabled}
      >
        {actionStatusMessage}
      </SmartButton>
    </div>
  )
}

export default SwapTokens
